<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
	name: string;
}>();

// Eager so the SVG source is inlined into the bundle instead of becoming one
// lazy chunk per icon. Resolution is then synchronous: no request per icon and
// the markup is part of the SSR output rather than appearing after hydration.
const icons = import.meta.glob<string>('../assets/images/icons/**.svg', {
	query: '?raw',
	import: 'default',
	eager: true,
});

const icon = computed(() => {
	if (!props.name) {
		return '';
	}

	const svg = icons[`../assets/images/icons/ico-${props.name}.svg`];

	if (!svg) {
		console.warn(`Icon 'ico-${props.name}.svg' doesn't exist in 'assets/images/icons'`);
		return '';
	}

	return svg;
});
</script>

<template>
	<span class="icon">
		<span
			class="icon__svg"
			aria-hidden="true"
			v-html="icon"
		/>
	</span>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.icon
	{
		flex-shrink:0;
		@include flex(center, center, null, true);
		pointer-events:none;

		&__svg
		{
			flex-shrink:0;
			@include size(inherit);

			&:deep(svg)
			{
				@include size(inherit);

				path
				{
					stroke-width:1.001;
				}
			}
		}
	}
}
</style>
